/* Dims shipping-bar message — externalized from sections/announcement-bar.liquid
   Reads config from #dims-shipping-bar-msg data-* attributes. Translations are
   pure JS literals; market/threshold/currency are set per-render via Liquid. */
(function () {
  var T = {
    'da': {
      dflt:   '✔️ Fragt fra 39,- og Gratis Fragt over {t}',
      below:  'Køb for {a} mere for Gratis Fragt',
      above:  '✔️ Tillykke – du har opnået Gratis Fragt!',
      noFree: '✔️ Billig fragt til Europa',
      suffix: '✔️ 1-2 hverdages levering ✔️ 4.9 / 5.0 på Trustpilot'
    },
    'en': {
      dflt:   '✔️ Shipping from €7.95 · Free shipping over {t}',
      below:  'Add {a} more for free shipping',
      above:  '✔️ Great – you’ve got free shipping!',
      noFree: '✔️ Cheap shipping to Europe',
      suffix: '✔️ 1-2 business days ✔️ 4.9 / 5.0 on Trustpilot'
    },
    'sv': {
      dflt:   '✔️ Frakt från 49 kr · Gratis frakt över {t}',
      below:  'Köp för {a} mer för Gratis Frakt',
      above:  '✔️ Grattis – du har uppnått Gratis Frakt!',
      noFree: '✔️ Billig frakt till Europa',
      suffix: '✔️ 1-2 vardagars leverans ✔️ 4,9 / 5,0 på Trustpilot'
    },
    'de': {
      dflt:   '✔️ Versand ab 7,95 € · Gratis Versand ab {t}',
      below:  'Noch {a} bis zum Gratisversand',
      above:  '✔️ Super – kostenloser Versand erzielt!',
      noFree: '✔️ Günstige Lieferung nach Europa',
      suffix: '✔️ 1-2 Werktage ✔️ 4,9 / 5,0 auf Trustpilot'
    },
    'fr': {
      dflt:   '✔️ Livraison dès 7,95 € · Livraison offerte dès {t}',
      below:  'Plus que {a} pour la livraison offerte',
      above:  '✔️ Super – vous bénéficiez de la livraison offerte !',
      noFree: '✔️ Livraison économique en Europe',
      suffix: '✔️ 1-2 jours ouvrés ✔️ 4,9 / 5,0 sur Trustpilot'
    },
    'nl': {
      dflt:   '✔️ Verzending vanaf €7,95 · Gratis verzending boven {t}',
      below:  'Nog {a} voor gratis verzending',
      above:  '✔️ Gefeliciteerd – gratis verzending bereikt!',
      noFree: '✔️ Voordelige verzending naar Europa',
      suffix: '✔️ 1-2 werkdagen ✔️ 4,9 / 5,0 op Trustpilot'
    },
    'it': {
      dflt:   '✔️ Spedizione da 7,95 € · Spedizione gratuita sopra {t}',
      below:  'Ancora {a} per la spedizione gratuita',
      above:  '✔️ Ottimo – spedizione gratuita raggiunta!',
      noFree: '✔️ Spedizione economica in Europa',
      suffix: '✔️ 1-2 giorni lavorativi ✔️ 4,9 / 5,0 su Trustpilot'
    },
    'es': {
      dflt:   '✔️ Envío desde 7,95 € · Envío gratis a partir de {t}',
      below:  'Faltan {a} para el envío gratis',
      above:  '✔️ ¡Genial – envío gratis conseguido!',
      noFree: '✔️ Envío económico a Europa',
      suffix: '✔️ 1-2 días hábiles ✔️ 4,9 / 5,0 en Trustpilot'
    },
    'pl': {
      dflt:   '✔️ Dostawa od 7,95 € · Darmowa dostawa powyżej {t}',
      below:  'Jeszcze {a} do darmowej dostawy',
      above:  '✔️ Świetnie – darmowa dostawa!',
      noFree: '✔️ Tania wysyłka do Europy',
      suffix: '✔️ 1-2 dni robocze ✔️ 4,9 / 5,0 na Trustpilot'
    },
    'fi': {
      dflt:   '✔️ Toimitus alkaen 7,95 € · Ilmainen toimitus yli {t}',
      below:  'Lisää {a} ilmaiseen toimitukseen',
      above:  '✔️ Hienoa – ilmainen toimitus!',
      noFree: '✔️ Edullinen toimitus Eurooppaan',
      suffix: '✔️ 1-2 arkipäivää  ✔️ Hintavertailu  ✔️ 4,9 / 5,0 Trustpilotissa'
    },
    'ro': {
      dflt:   '✔️ Livrare de la 7,95 € · Livrare gratuită de la {t}',
      below:  'Mai adaugă {a} pentru livrare gratuită',
      above:  '✔️ Felicitări – ai livrare gratuită!',
      noFree: '✔️ Livrare ieftină în Europa',
      suffix: '✔️ 1-2 zile lucrătoare ✔️ 4,9 / 5,0 pe Trustpilot'
    },
    'cs': {
      dflt:   '✔️ Doprava od 7,95 € · Doprava zdarma nad {t}',
      below:  'Do dopravy zdarma zbývá {a}',
      above:  '✔️ Skvěle – doprava zdarma!',
      noFree: '✔️ Levné doručení do Evropy',
      suffix: '✔️ 1-2 pracovní dny ✔️ 4,9 / 5,0 na Trustpilot'
    },
    'no': {
      dflt:   '✔️ Frakt fra 49 kr · Gratis frakt over {t}',
      below:  'Kjøp for {a} mer for Gratis Frakt',
      above:  '✔️ Flott – du har oppnådd Gratis Frakt!',
      noFree: '✔️ Billig frakt til Europa',
      suffix: '✔️ 1-2 virkedager ✔️ 4,9 / 5,0 på Trustpilot'
    }
  };

  var FMT = {
    'DKK': function(c) { return Math.ceil(c / 100).toLocaleString('da-DK') + ' kr.'; },
    'SEK': function(c) { return Math.ceil(c / 100).toLocaleString('sv-SE') + ' kr.'; },
    'EUR': function(c) { return Math.ceil(c / 100).toLocaleString('de-DE') + ' €'; },
    'PLN': function(c) { return Math.ceil(c / 100).toLocaleString('pl-PL') + ' zł'; },
    'CZK': function(c) { return Math.ceil(c / 100).toLocaleString('cs-CZ') + ' Kč'; },
    'RON': function(c) { return Math.ceil(c / 100).toLocaleString('ro-RO') + ' lei'; }
  };

  function run() {
    var el = document.getElementById('dims-shipping-bar-msg');
    if (!el) return;

    var threshold  = parseFloat(el.dataset.threshold  || '0') * 100;
    var currency   = el.dataset.currency   || 'DKK';
    var noFree     = el.dataset.noFree     === 'true';
    var threshDisp = el.dataset.thresholdDisplay || '';

    var lang = (document.documentElement.lang || 'da').split('-')[0].toLowerCase();
    var tr   = T[lang] || T['en'];
    var fmt  = FMT[currency] || FMT['DKK'];

    var trSuffix = tr.suffix || '';
    var sep = trSuffix ? ' <span class="dims-bar-sep">·</span> ' + trSuffix : '';

    function update(totalCents) {
      var html;
      if (noFree || threshold <= 0) {
        html = tr.noFree;
      } else if (totalCents <= 0) {
        html = tr.dflt.replace('{t}', threshDisp);
      } else if (totalCents >= threshold) {
        html = tr.above;
      } else {
        html = tr.below.replace('{a}', fmt(threshold - totalCents));
      }
      el.innerHTML = html + sep;
    }

    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(c) { update(c.total_price); })
      .catch(function()  { update(0); });

    document.addEventListener('cart:refresh', function() {
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) { update(c.total_price); });
    });
    document.addEventListener('cart:updated', function(e) {
      if (e.detail && e.detail.cart) update(e.detail.cart.total_price);
      else fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) { update(c.total_price); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
